<app-breadcrumb [title]="'Registrar'" [items]="['Pesv']" [active_item]="'Registrar'"></app-breadcrumb>
<div class="container-fluid pesv-page">

  <div class="card pesv-main-card">
    <div class="card-header d-flex align-items-center pesv-header">
      <div class="pesv-header-icon"><i class="icofont icofont-verification-check"></i></div>
      <div class="pesv-header-content"><h4 class="mb-1">LÍDER PESV</h4><p class="mb-0">Designación y seguimiento del líder del Plan Estratégico de Seguridad Vial</p></div>
      <div class="pesv-header-badge"><i class="icofont icofont-shield-alt"></i><div><strong>Gestión PESV</strong><small>Control de designaciones</small></div></div>
    </div>
    <div class="card-body pesv-main-body">
      <div class="col-sm-12 col-xl-12">
        <ul ngbNav #nav="ngbNav" class="nav-tabs pesv-tabs" (navChange)="onTabChange($event)">
          <li [ngbNavItem]="1">

            <a ngbNavLink><i class="icofont icofont-user-alt-7 me-2"></i><strong>DESIGNAR LÍDER PESV</strong></a>

            <ng-template ngbNavContent>
              <form [formGroup]="formPesv">
                
                <div class="card shadow-sm border-0 mt-3 pesv-section-card">
                  
                
                  <div class="card-body">
                
                    <div class="row g-3 align-items-end">
                
                      <div class="col-12 col-md-8 col-lg-4">
                        <label class="form-label fw-bold">
                          Número de identificación
                          <span class="text-danger">*</span>
                        </label>
                
                        <div class="input-group">
                          <span class="input-group-text">
                            <i class="icofont icofont-id-card"></i>
                          </span>
                
                          <input type="number" class="form-control" placeholder="Ingrese el número de documento del colaborador"
                            formControlName="cedula">
                        </div>
                      </div>
                
                      <div class="col-12 col-md-4 col-lg-3">
                        <button type="button" class="btn btn-primary " (click)="buscar()" [disabled]="cargando">
                
                          <span *ngIf="!cargando">
                            <i class="icofont icofont-search me-1"></i>
                            Buscar
                          </span>
                
                          <span *ngIf="cargando">
                            <span class="spinner-border spinner-border-sm me-2"></span>
                            Consultando...
                          </span>
                
                        </button>
                      </div>
                
                    </div>
                
                    <div class="row mt-2">
                      <div class="col-lg-6">
                        <small class="text-dark">
                          Digite el número de documento para consultar la información del colaborador.
                        </small>
                      </div>
                    </div>
                
                    <div class="alert alert-info border-0 mt-4 mb-0" *ngIf="!propietario">
                
                      <div class="d-flex align-items-start">
                        <i class="icofont icofont-info-circle fs-4 me-2"></i>
                
                        <div>
                          <strong>Designación del Líder PESV</strong>
                          <p class="mb-0 mt-1">
                            Seleccione un colaborador que represente el máximo nivel directivo
                            o cuente con la autoridad necesaria para liderar, coordinar y
                            garantizar la implementación efectiva del PESV dentro de la organización.
                          </p>
                        </div>
                      </div>
                
                    </div>
                
                  </div>
                </div>

                <!-- BLOQUE 2: DATOS COLABORADOR -->
                <div class="mt-4 pesv-content-section" *ngIf="propietario">
                  <div class="card pesv-section-card rounded">
                    <div class="card-header pesv-section-header">
                      <div class="pesv-section-title"><span class="pesv-title-icon"><i class="icofont icofont-user-alt-7"></i></span><div><h5 class="mb-0">INFORMACIÓN DEL COLABORADOR</h5><small>Verifique los datos antes de realizar la designación.</small></div></div>
                    </div>
                    <div class="card-body">
                      <div class="row collaborator-info-row">
                        <div class="col-12 col-md-6 col-lg-3">
                          <div class="collaborator-info-box">
                            <div class="info-label">NÚMERO DE IDENTIFICACIÓN</div>
                            <div class="info-value text-primary fw-semibold">{{ propietario.cedula }}</div>
                          </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-5">
                          <div class="collaborator-info-box">
                            <div class="info-label">NOMBRE COMPLETO</div>
                            <div class="info-value">
                              {{ propietario.primernombre }}
                              {{ propietario.segundonombre }}
                              {{ propietario.papellidos }}
                              {{ propietario.seapellidos }}
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-2">
                          <div class="collaborator-info-box">
                            <div class="info-label">CARGO</div>
                            <div class="info-value">{{ propietario.cargoData?.cargos || '-' }}</div>
                          </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-2">
                          <div class="collaborator-info-box">
                            <div class="info-label">VINCULACIÓN</div>
                            <div class="info-value">{{ propietario.condicionLaboral?.label || '-' }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- BLOQUE 3: DESIGNACIÓN PESV -->
                <div class="mt-0" *ngIf="propietario">
                  <div class="card pesv-section-card rounded">
                    <div class="card-header pesv-section-header">
                      <div class="pesv-section-title"><span class="pesv-title-icon"><i class="icofont icofont-file-document"></i></span><div><h5 class="mb-0">DESIGNACIÓN DEL LÍDER PESV</h5><small>Registre la fecha y adjunte el documento soporte.</small></div></div>
                    </div>
                    <div class="card-body">
                      <div class="row g-3">
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                          <label class="form-label fw-bold">FECHA DE DESIGNACIÓN: <span class="text-danger">*</span></label>
                          <input type="date" class="form-control" formControlName="fecha_designacion"
                            [max]="fechaDesignacionMax" placeholder="Seleccione la fecha de designacion">
                        </div>
                      </div>

                     <div class="row mt-4">
  <div class="col-12">

    <label class="form-label fw-bold mb-2">
      DOCUMENTO SOPORTE DEL LÍDER PESV (SOLO ARCHIVO PDF): <span class="text-danger" *ngIf="!archivoSoporteSeleccionado">*</span>
      
    </label>

    <input
      type="file"
      class="d-none"
      id="fileInputLiderPesv"
      [attr.accept]="acceptDocumentoSoporte"
      (change)="onFileChange($event)" />

    <div class="card shadow-sm border-0 pesv-upload-card">

      <div class="card-body">

        <label
          for="fileInputLiderPesv"
          class="dropzone-label d-flex flex-column justify-content-center align-items-center border border-primary rounded w-100"
          tabindex="0"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDropDocumentoSoporte($event)">

          <ng-container *ngIf="archivoSoporteSeleccionado; else noFileLider">

            <i class="icofont icofont-file-document text-primary mb-3"
              style="font-size: 60px;">
            </i>

            <h6 class="text-primary fw-bold mb-1">
              Archivo seleccionado
            </h6>

            <small
              class="text-center text-muted px-3"
              [title]="archivoSoporteSeleccionado?.name">

              {{ archivoSoporteSeleccionado?.name }}

            </small>

          </ng-container>

          <ng-template #noFileLider>

            <i class="icofont icofont-upload text-primary mb-3"
              style="font-size: 60px;">
            </i>

            <h6 class="text-primary fw-bold text-uppercase mb-1">
              Cargar soporte del Líder PESV
            </h6>

            <small class="text-muted text-center">
              Arrastre un archivo aquí o haga clic para seleccionarlo
            </small>

          </ng-template>

        </label>

      </div>

      <div
        class="card-footer bg-white border-0 pt-0"
        *ngIf="archivoSoporteSeleccionado">

        <div class="d-flex justify-content-center gap-3">

          <button
            class="btn btn-outline-primary"
            type="button"
            (click)="descargarArchivoSoporteSeleccionado()">

            <i class="icofont icofont-download"></i>
            Descargar

          </button>

          <button
            class="btn btn-outline-danger"
            type="button"
            (click)="removeArchivoSoporte()">

            <i class="icofont icofont-trash"></i>
            Eliminar

          </button>

        </div>

      </div>

    </div>

  </div>
</div>

                     <!--  <div class="row g-3">
                        <div class="col-12">
                          <label class="form-label fw-bold">FUNCIONES DEL LÍDER PESV: <span class="text-danger"
                              *ngIf="!archivoSoporteSeleccionado">*</span></label>
                          <textarea class="form-control" rows="4" formControlName="funcion"
                            placeholder="Describa las funciones y responsabilidades asignadas al Líder PESV"></textarea>
                          <small class="text-black" *ngIf="archivoSoporteSeleccionado">
                            Campo deshabilitado porque se cargó documento soporte.
                          </small>
                        </div>
                      </div> -->

                     
<div
  class="pesv-notice mb-3 mt-4"
  [ngClass]="liderActivoExistente ? 'pesv-notice-warning' : 'pesv-notice-info'">

  <div class="pesv-notice-icon">
    <i
      class="icofont"
      [ngClass]="liderActivoExistente
        ? 'icofont-warning-alt'
        : 'icofont-info-circle'">
    </i>
  </div>

                  <div class="pesv-notice-content">
                  
                    <ng-container *ngIf="liderActivoExistente; else liderDisponible">
                      <strong>Ya existe un líder PESV activo</strong>
                      <p>
                        Para designar un nuevo líder, primero debes inactivar la designación
                        vigente desde la pestaña <strong>Historial Líder PESV</strong>.
                      </p>
                    </ng-container>
                  
                    <ng-template #liderDisponible>
                      <strong>Importante: registro para auditoría</strong>
                      <p>
                        La designación quedará registrada como parte del historial de gestión
                        del Plan Estratégico de Seguridad Vial (PESV).
                      </p>
                    </ng-template>
                  
                  </div>
                  </div>


                      <div class="d-grid d-md-flex justify-content-md-end">
                        <button class="btn btn-success px-4" type="button" (click)="create()"
                          [disabled]="cargando || formPesv.invalid || liderActivoExistente">
                          <span *ngIf="!cargando">
                            <i class="icofont icofont-save"></i> Designar Líder PESV
                          </span>
                          <span *ngIf="cargando">
                            <span class="spinner-border spinner-border-sm"></span> Guardando...
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">

            <a ngbNavLink><i class="icofont icofont-history me-2"></i><strong>HISTORIAL LÍDER PESV</strong></a>

            <ng-template ngbNavContent>
              <div class="card-body">
                    <div class="row mb-3" *ngIf="!cargandoHistorial">
                      <div class="col-sm-12 col-md-4 ms-auto">
                        <div class="input-group">
                          <input type="text" class="form-control" placeholder="Buscar en historial..."
                            [(ngModel)]="searchTextHistorial" (input)="aplicarFiltroHistorial()" />
                          <span class="input-group-text">
                            <i class="fa fa-search"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Loader -->
                    <div *ngIf="cargandoHistorial" class="text-center py-5 pesv-loading-state">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                      </div>
                      <p class="mt-2">Cargando historial...</p>
                    </div>

                    <!-- Tabla de historial -->
                    <div *ngIf="!cargandoHistorial && filteredHistorialLideres.length > 0" class="table-responsive">
                      <div class="table-responsive my-4">
                      
<div class="table-responsive pesv-history-table-wrap">
  <table class="table table-hover align-middle pesv-history-table" id="tblExtractos">
    <thead>
      <tr>
        <th class="text-center"><strong>ID</strong></th>
        <th class="text-center"><strong>CÉDULA</strong></th>
        <th><strong>NOMBRE COMPLETO</strong></th>
        <th><strong>CARGO</strong></th>
        <th class="text-center"><strong>FECHA DESIGNACIÓN</strong></th>
        <th class="text-center"><strong>FECHA RETIRO</strong></th>
        <th class="text-center"><strong>ESTADO</strong></th>
        <th class="text-center"><strong>FECHA REGISTRO</strong></th>
        <th><strong>USUARIO</strong></th>
        <th class="text-center"><strong>ACCIONES</strong></th>
      </tr>
    </thead>

    <tbody>
      <tr
        *ngFor="let lider of filteredHistorialLideres | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">

        <td class="text-center pesv-cell-id">
          {{ lider.id }}
        </td>

        <td class="text-center pesv-cell-document">
          {{ lider.cedula }}
        </td>

        <td class="pesv-name-cell">
          {{ lider.nombre }}
        </td>

        <td>
          {{ lider.cargo }}
        </td>

        <td class="text-center pesv-cell-date">
          {{ formatDateTodo(lider.fecha_designacion) }}
        </td>

        <td class="text-center pesv-cell-date">
          
          {{ lider.estado === 1 ? '-' : (lider.fechamodificacion) }}
        </td>

        <td class="text-center">
          <span
            *ngIf="lider.estado === 1"
            class="badge pesv-status-active">
            <i class="icofont icofont-check-circled"></i>
            ACTIVO
          </span>

          <span
            *ngIf="lider.estado === 0"
            class="badge pesv-status-inactive">
            <i class="icofont icofont-close-circled"></i>
            INACTIVO
          </span>
        </td>

        <td class="text-center pesv-cell-date">
          {{ lider.fecharegistro }}
        </td>

        <td class="pesv-cell-user">
          {{ lider.creado_por }}
        </td>

        <td class="text-center">
          <div class="action pesv-row-actions">
            <ul class="list-inline mb-0">

              <!-- Visualizar documento -->
              <li class="list-inline-item">
                <a
                  href="javascript:void(0)"
                  (click)="VerDocumentoLider(lider)"
                  [class.disabled]="descargandoLiderId === lider.id"
                  [style.pointer-events]="descargandoLiderId === lider.id ? 'none' : 'auto'"
                  [attr.aria-label]="'Visualizar documento del líder ' + lider.nombre"
                  ngbTooltip="Visualizar documento">

                  <i
                    class="icon-eye"
                    *ngIf="descargandoLiderId !== lider.id">
                  </i>

                  <span
                    class="spinner-border spinner-border-sm"
                    *ngIf="descargandoLiderId === lider.id">
                  </span>
                </a>
              </li>

              <!-- Descargar documento -->
              <li class="list-inline-item">
                <a
                  href="javascript:void(0)"
                  (click)="descargarDocumentoLider(lider)"
                  [class.disabled]="descargandoLiderId === lider.id"
                  [style.pointer-events]="descargandoLiderId === lider.id ? 'none' : 'auto'"
                  [attr.aria-label]="'Descargar documento del líder ' + lider.nombre"
                  ngbTooltip="Descargar documento">

                  <i
                    class="icon-download"
                    *ngIf="descargandoLiderId !== lider.id">
                  </i>

                  <span
                    class="spinner-border spinner-border-sm"
                    *ngIf="descargandoLiderId === lider.id">
                  </span>
                </a>
              </li>

              <!-- Inactivar únicamente líderes activos -->
              <li class="list-inline-item" *ngIf="lider.estado === 1">
                <a
                  href="javascript:void(0)"
                  class="pesv-action-delete"
                  (click)="inactivarLider(lider.id)"
                  [attr.aria-label]="'Inactivar líder ' + lider.nombre"
                  ngbTooltip="Inactivar líder">

                  <i class="icon-trash"></i>
                </a>
              </li>

            </ul>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>


                      </div>

                     

                      <div class="mt-3 d-flex justify-content-center flex-wrap gap-2 pesv-export-actions">
                        <button class="btn btn-outline-success-2x btn-sm" type="button"
                          (click)="exportarExcelHistorial()">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>
                        <button class="btn btn-outline-danger-2x btn-sm" type="button" (click)="exportarPdfHistorial()">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>
                      </div>

                      <div style="position: absolute; left: -99999px; top: -99999px;">
                        <table class="table table-hover table-bordered" id="tblExtractosExport">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>CEDULA</th>
                              <th>NOMBRE COMPLETO</th>
                              <th>CARGO</th>
                              <th>FECHA DESIGNACION</th>
                              <th>ESTADO</th>
                              <th>FECHA REGISTRO</th>
                              <th>USUARIO</th>
                              <th>ACCIONES</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let lider of historialLideres">
                              <td>{{ lider.id }}</td>
                              <td>{{ lider.cedula }}</td>
                              <td>{{ lider.nombre }}</td>
                              <td>{{ lider.cargo }}</td>
                              <td>{{ formatDateTodo(lider.fecha_designacion) }}</td>
                              <td>{{ lider.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}</td>
                              <td>{{ lider.fecharegistro }}</td>
                              <td>{{ lider.creado_por }}</td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Sin resultados -->
                    <div *ngIf="!cargandoHistorial && filteredHistorialLideres.length === 0" class="text-center py-5 pesv-empty-state">
                      <i class="icofont icofont-database" style="font-size: 48px; color: #ccc;"></i>
                      <p class="mt-3 text-primary">No hay registros de líderes PESV</p>
                    </div>
                  </div>
            </ng-template>
          </li>
        </ul>
      </div>
      <div [ngbNavOutlet]="nav" class="mt-2 pesv-nav-content"></div>

    </div>

  </div>


</div>

<ng-template #modalVistaPreviaDocumento let-modal>
  <div class="modal-header pesv-modal-header">
    <h5 class="modal-title">{{ documentoVistaPreviaTitulo }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0 pesv-document-preview">
    <iframe *ngIf="documentoVistaPreviaUrl" [src]="documentoVistaPreviaUrl" title="Vista previa documento líder PESV"
      ></iframe>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
    <button type="button" class="btn btn-primary" (click)="descargarDocumentoActual()">Descargar</button>
  </div>
</ng-template>